import React from 'react';
import { BOX_IMAGE, CHECKOUT_URL, PURCHASE_ANCHOR } from '../data/content';
type Target = 'purchase' | 'checkout';
function hrefFor(target: Target) {
  return target === 'checkout' ? CHECKOUT_URL : PURCHASE_ANCHOR;
}
interface CTAButtonProps {
  label: string;
  sub?: string;
  target?: Target;
  className?: string;
}
export function CTAButton({
  label,
  sub,
  target = 'purchase',
  className = ''
}: CTAButtonProps) {
  return <a href={hrefFor(target)} className={`block w-full rounded-md bg-gold px-4 py-3 text-center font-body text-[0.92rem] font-extrabold uppercase leading-tight tracking-wide text-navy shadow-[0_5px_0_0_#A67C22] transition-[background-color,transform,box-shadow] duration-150 ease-out hover:bg-[#E2B454] active:translate-y-[3px] active:shadow-[0_2px_0_0_#A67C22] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/40 sm:text-lg ${className}`} data-id="element-27" data-mp="2txs0k8s498n1">
      {label}
      {sub ? <span className="mt-0.5 block text-[0.66rem] font-semibold normal-case tracking-normal text-navy/80" data-id="element-28" data-mp="38q3lr34adkmf">
          {sub}
        </span> : null}
    </a>;
}
interface BoxImageProps {
  className?: string;
  target?: Target;
}
export function BoxImage({
  className = '',
  target = 'purchase'
}: BoxImageProps) {
  return <a href={hrefFor(target)} className={`block ${className}`} data-id="element-29" data-mp="1n8o2jl7bpinv">
      <img src={BOX_IMAGE} alt="ULTRASOUND VISUAL ATLAS™ complete 6-in-1 visual study system box set" className="mx-auto w-full drop-shadow-2xl" data-id="element-30" data-mp="1na8v55a2urj3" />
    </a>;
}